export default __webpack_public_path__ + "media/chat.5535a0fe.svg";